import cn from 'classnames/bind';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { Label } from 'ui';
import ReadTime from 'ui/components/blog/ReadTime';
import { classNameType, colorType } from 'utils/types';

import s from './BlogMetaInfo.module.scss';

const cx = cn.bind(s);

const BlogMetaInfo = ({
  label, labelColor, readTime, category, hasReadLabel = false, className, ...attrs
}) => (
  <div className={cx('info', className)} {...attrs}>
    {label && labelColor && (
      <Label color={labelColor} className={cx('label')}>
        {label}
      </Label>
    )}
    {!!readTime && (
      <div className={cx('readTime', "flex items-center")}>
        {hasReadLabel && <span className="tp-hint mr-[5px]">Time to read: </span>}
        <ReadTime time={readTime} />
      </div>
    )}
    {category && (
      <Link href={`/${category}`} className={cx('link')}>
        {category}
      </Link>
    )}
  </div>
);

BlogMetaInfo.propTypes = {
  label: PropTypes.string,
  labelColor: colorType,
  readTime: PropTypes.number,
  category: PropTypes.string,
  className: classNameType,
};

export default BlogMetaInfo;
